<div class="d-flex flex-column h-100">
  <app-toast />
  <app-navbar />
  @if (!browserSupported) {
    <div class="alert alert-danger text-center mb-0">
      ALERT: We've detected an unsupported web browser. Continuing with this browser will likely result in poor
      functionality. Please use recent versions Google Chrome, Mozilla Firefox or Microsoft Edge to access NuvemRX web
      applications.
    </div>
  }
  <div class="main" [ngClass]="{ 'container-fluid': legacyLayout }"><router-outlet /></div>
  @if (showFatFooter) {
    <app-fat-footer />
  }
</div>
